import { FC, memo, useCallback } from 'react';
import type { KeyboardEvent as ReactKeyboardEvent } from 'react';
import { TaskTitleSection } from '../TaskTitleSection';
import './TaskTitleDescriptionSection.scss';

interface TaskTitleDescriptionSectionProps {
  isEditMode: boolean;
  isReadOnly?: boolean;
  completed?: boolean;
  showCheckbox?: boolean;
  onSave: (title: string, desc: string) => void;
  onCompletedChange?: (completed: boolean) => void;
  disabledTooltipTitle?: string;
  name: string;
  desc: string;
  onNameChange: (name: string) => void;
}

export const TaskTitleDescriptionSection: FC<TaskTitleDescriptionSectionProps> = memo(
  ({
    isEditMode,
    isReadOnly = false,
    completed = false,
    showCheckbox = false,
    onSave,
    onCompletedChange,
    disabledTooltipTitle = '',
    name,
    desc,
    onNameChange,
  }) => {
    const handleTitleKeyDown = useCallback(
      (event: ReactKeyboardEvent<HTMLInputElement>) => {
        if (event.key !== 'Enter' || event.shiftKey || event.nativeEvent.isComposing) {
          return;
        }

        event.preventDefault();

        if (name.trim() && !isReadOnly) {
          onSave(name, desc);
        }
      },
      [isReadOnly, onSave, name, desc]
    );

    return (
      <div className="task-title-description-section">
        <TaskTitleSection
          title={name}
          autoFocus={!isEditMode}
          isReadOnly={isReadOnly}
          completed={completed}
          showCheckbox={showCheckbox}
          onTitleChange={onNameChange}
          onTitleKeyDown={handleTitleKeyDown}
          onCompletedChange={onCompletedChange}
          disabledTooltipTitle={disabledTooltipTitle}
        />
      </div>
    );
  }
);

TaskTitleDescriptionSection.displayName = 'TaskTitleDescriptionSection';

export { TaskDescriptionField } from './TaskDescriptionField';
